// expose any utilities/library functions referenced directly from the server side
import translateWithMissedKeysDetection from './translations/translateWithMissedKeysDetection'

export default {
  translateWithMissedKeysDetection,
}
